import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'

export default props => {
    useStyles(classes)
    return <div className={classes.Container}>
        <div className={classes.Title}>
            {props.children}
        </div>
        <div className={classes.Tool} onClick={props?.onClick}>
            <span className={classes.Label}>
                {props.value}
            </span>
            <Iconfont className={classes.Sword}>&#xe7c7;</Iconfont>
        </div>
    </div>
}